import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";

class ZapierService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  postCompany(companyExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/send-by-company?companyExternalId=${companyExternalId}`, {});
  }
}

export default new ZapierService("/api/zapier");
